import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * ScrollToTop - restores window scroll to (0,0) on every route change.
 *
 * Mounted once inside <BrowserRouter> at the Layout level so it covers
 * every route. Hash-only navigation (e.g. `/#calculator`) is intentionally
 * bypassed so existing anchor-scroll handlers (Home.jsx + the Products
 * mega-menu Field Calculator handler) keep working unchanged.
 */
export const ScrollToTop = () => {
    const { pathname, hash } = useLocation();
    useEffect(() => {
        if (hash) return; // let anchor links handle themselves
        window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
    }, [pathname, hash]);
    return null;
};

export default ScrollToTop;
